module.exports = __webpack_public_path__ + "static/media/hamburger-bg.45090fb2.png";